import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";
import { api } from "../lib/api";

export function usePageTracking() {
  const location = useLocation();
  const user = useAuth((state) => state.user);
  const isLoading = useAuth((state) => state.isLoading);
  const sessionChecked = useAuth((state) => state.sessionChecked);

  useEffect(() => {
    // Public routes (login, demo and invitation activation) have no session.
    // Do not turn their ordinary anonymous state into a 401 redirect loop.
    if (!sessionChecked || isLoading || !user) return;
    const timer = window.setTimeout(() => {
      api
        .post("/api/audit/event", {
          action: "page_view",
          target: location.pathname,
        }, { skipErrorToast: true } as never)
        .catch(() => {
          // Audit logging is best-effort — never block the UI
        });
    }, 8_000);
    return () => window.clearTimeout(timer);
  }, [isLoading, location.pathname, sessionChecked, user?.user_id, user?.role]);
}
